<div class="row" style="text-align: center; align-items: center; justify-content: center; justify-items: stretch">
  <a href="https://twitter.com" class="col" [href]="'https://x.com/emioduntan'" [target]="'_blank'">
    <img src="../../../../assets/images/shared/twitter.png" alt="twitter" />
  </a>
  <a href="https://linkedin.com" class="col" [href]="'https://www.linkedin.com/company/living-meaningfully/'" [target]="'_blank'">
    <img src="../../../../assets/images/shared/linkedin.png" alt="linkedIn" />
  </a>
  <a href="https://facebook.com" class="col" [href]="'https://www.facebook.com/people/Living-Meaningfully/100064825025109/'" [target]="'_blank'">
    <img src="../../../../assets/images/shared/facebook.png" alt="facebook" style="height: 3rem" />
  </a>
  <a href="https://instagram.com" class="col" [href]="'https://www.instagram.com/living_meaningfully'" [target]="'_blank'">
    <img src="../../../../assets/images/shared/instagram.png" alt="instagram" />
  </a>
</div>
